import { Pipe, PipeTransform } from '@angular/core';

import { BatchRegistryUploadError } from 'features/organization-settings/registry/batch-registry-upload/batch-registry-upload.model';

@Pipe({ name: 'findErrorByFieldLabel' })
export class FindErrorByFieldLabelPipe implements PipeTransform {
  transform(errors: BatchRegistryUploadError[], fieldLabel: string): string {
    if (!errors || !(errors instanceof Array)) {
      return '';
    }
    const error = errors.find(_error => _error.columnName.toLowerCase() === fieldLabel.toLowerCase());
    return error ? error.errorMessage : '';
  }
}
